<template>
  <v-card>
    <v-toolbar flat>
        <v-toolbar-title class="text-h6 font-weight-regular">Save and Upload CSV</v-toolbar-title>
    </v-toolbar>
    <v-container class="ma-0 mp-0">
      <v-form ref="matchCsvForm" autocomplete="off">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="4">
              <v-subheader>What do you want to name this datasource?</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="name"
                label="Datasource Name"
                required
                :rules="vruleFieldRequired"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import StepHelperMixin from './StepHelperMixin'
import { mapActions } from 'vuex'
import { hasValue } from '@/utils'

export default {
  name: 'save-csv',
  mixins: [validationMixin, StepHelperMixin],
  data: function () {
    return {
    }
  },
  computed: {
    name: {
      get () {
        return this.$store.state.CsvMappingStore.name
      },
      set (val) {
        this.updateMapping({ name: val })
      }
    }
  },
  watch: {
    name () {
      this.validateStep()
    }
  },
  methods: {
    ...mapActions('CsvMappingStore', ['updateMapping']),

    validateStep () {
      this.setStepIsValid(hasValue(this.name))
    }
  }
}
</script>
